const RENDERER_FAILURE_CODES = {
    AUDIO_DOWNLOADING: 0,
    AUDIO_ENCODING: 1,
    AUDIO_ANALYZING: 2,
    LOGO_DOWNLOADING: 3,
    BACKGROUND_VIDEO_TRANSFORMING: 4,
    BACKGROUND_VIDEO_DOWNLOADING: 5,
    BACKGROUND_IMAGE_DOWNLOADING: 6,
    BACKGROUND_IMAGE_TRANSFORMING: 7,
    VIDEO_RENDERING: 8,
    VIDEO_UPLOADING: 9,
    VIDEO_PIECES_CONCATENATING: 10,
    AUDIO_VIDEO_MERGING: 11,
    UNKNOWN: 12
}

export const getExportFailureMessage = (rendererFailureCode, watermarkedExport = true) => {
    switch (rendererFailureCode) {
        case RENDERER_FAILURE_CODES.AUDIO_DOWNLOADING:
        case RENDERER_FAILURE_CODES.AUDIO_ENCODING:
        case RENDERER_FAILURE_CODES.AUDIO_ANALYZING:
            return `
                It looks like there was an issue with your export. We've issued a credit for the failed attempt.
                The problem may have been caused by your audio file. We recommend re-encoding or re-uploading the file and trying the export again.
                ${!watermarkedExport ? 'If the issue persists, feel free to reach out to us at help@specterr.com.' : ''}
            `;
        case RENDERER_FAILURE_CODES.LOGO_DOWNLOADING:
            return `
                It looks like there was an issue with your export. We've issued a credit for the failed attempt.
                The problem may have been caused by your logo image. We recommend re-encoding or re-uploading the file and trying the export again.
                ${!watermarkedExport ? 'If the issue persists, feel free to reach out to us at help@specterr.com.' : ''}
            `;
        case RENDERER_FAILURE_CODES.BACKGROUND_VIDEO_DOWNLOADING:
        case RENDERER_FAILURE_CODES.BACKGROUND_IMAGE_DOWNLOADING:
        case RENDERER_FAILURE_CODES.BACKGROUND_VIDEO_TRANSFORMING:
        case RENDERER_FAILURE_CODES.BACKGROUND_IMAGE_TRANSFORMING:
            return `
                It looks like there was an issue with your export. We've issued a credit for the failed attempt.
                The problem may have been caused by your background image or video. We recommend re-encoding or re-uploading the file and trying the export again.
                ${!watermarkedExport ? 'If the issue persists, feel free to reach out to us at help@specterr.com.' : ''}
            `;
        case RENDERER_FAILURE_CODES.VIDEO_RENDERING:
        case RENDERER_FAILURE_CODES.VIDEO_UPLOADING:
        case RENDERER_FAILURE_CODES.VIDEO_PIECES_CONCATENATING:
        case RENDERER_FAILURE_CODES.AUDIO_VIDEO_MERGING:
        case RENDERER_FAILURE_CODES.UNKNOWN:
            return `
                It looks like there was an issue with your export. We've issued a credit for the failed attempt. You may try again.
                ${!watermarkedExport ? 'If the issue persists, feel free to reach out to us at help@specterr.com.' : ''}
            `;
        default:
            return `
                It looks like there was an issue with your export. We've issued a credit for the failed attempt. You may try again.
                ${!watermarkedExport ? 'If the issue persists, feel free to reach out to us at help@specterr.com.' : ''}
            `;
    }
};